<template>
  <slot v-if="!isPastVisible"></slot>
</template>

<script setup>
import { computed } from 'vue';
import { SPECIAL_MONTH_ID_PAST } from '@/components/organisms/calendar-vertical/use-calendar-months';
import { useSharedState } from '@composables/use-shared-state';

const { state: sharedState } = useSharedState({ id: 'calendar-vertical' });

const isPastVisible = computed(
  () => sharedState.selectedMonthId === SPECIAL_MONTH_ID_PAST
);
</script>
